import { render, staticRenderFns } from "./CarouselEffectFade.vue?vue&type=template&id=69f0cf6c&scoped=true&"
import script from "./CarouselEffectFade.vue?vue&type=script&lang=js&"
export * from "./CarouselEffectFade.vue?vue&type=script&lang=js&"
import style0 from "./CarouselEffectFade.vue?vue&type=style&index=0&id=69f0cf6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f0cf6c",
  null
  
)

export default component.exports